import { Observable, throwError } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';

type ObservableTtlCacheEntry<T> = {
  response$: Observable<T>;
  expiresAt: number;
};

export class ObservableTtlCache<T> {
  private readonly entries = new Map<string, ObservableTtlCacheEntry<T>>();

  constructor(private readonly ttlMs: number) {}

  get(key: string, requestFactory: () => Observable<T>): Observable<T> {
    const cachedEntry = this.entries.get(key);
    if (cachedEntry && cachedEntry.expiresAt > Date.now()) {
      return cachedEntry.response$;
    }

    const response$ = requestFactory().pipe(
      catchError((error) => {
        this.entries.delete(key);
        return throwError(() => error);
      }),
      shareReplay({ bufferSize: 1, refCount: false }),
    );

    this.entries.set(key, {
      response$,
      expiresAt: Date.now() + this.ttlMs,
    });

    return response$;
  }

  delete(key: string): void {
    this.entries.delete(key);
  }

  clear(): void {
    this.entries.clear();
  }
}
